/* Corte: Adulto / Mujer / Niño (v7.1).

   Las camisas de NBA, NFL y MLB tienen dos opciones: Corte y Talla. Cada
   corte trae sus propias tallas (adulto S–XXL, mujer S–XL, niño 20–26), asi
   que al elegir un corte se esconden las tallas que no existen para el y,
   si la talla marcada ya no sirve, se marca la primera que si.

   Funciona igual en la ficha (.pdp-opt .chip + [data-variantes]) y en la
   vista rapida (#vista-rapida, chips [data-vr-op]). Escucha en fase de
   captura: corre ANTES que tlr.js / tlr-vista.js, que despues buscan la
   variante con lo que quedo marcado. Si no, «Niño + S» no existe y el
   carrito se quedaba con la variante anterior. */
(function () {
  "use strict";

  /* Los chips son inline-flex: sin esto el atributo hidden no los esconde. */
  var st = document.createElement("style");
  st.textContent = ".pdp-opt .chip[hidden]{display:none!important}";
  document.head.appendChild(st);

  function chipsDe(fs) { return Array.prototype.slice.call(fs.querySelectorAll(".chip")); }
  function valorDe(c) { return c.getAttribute("data-vr-val") || c.getAttribute("data-val"); }

  /* Recalcula todo el grupo de opciones. forzado = {fieldset, valor} del
     clic en curso (todavia no esta marcado cuando esto corre). */
  function ajustar(raiz, variantes, forzado) {
    var grupos = Array.prototype.slice.call(raiz.querySelectorAll(".pdp-opt"));
    if (grupos.length < 2 || !variantes || !variantes.length) { return; }
    var sel = grupos.map(function (fs) {
      if (forzado && forzado.fs === fs) { return forzado.valor; }
      var on = fs.querySelector('.chip[aria-pressed="true"]');
      return on ? valorDe(on) : null;
    });
    for (var i = 1; i < grupos.length; i++) {
      var validos = {};
      variantes.forEach(function (v) {
        for (var j = 0; j < i; j++) { if (sel[j] !== null && v.options[j] !== sel[j]) { return; } }
        validos[v.options[i]] = true;
      });
      var primero = null, sigue = false;
      chipsDe(grupos[i]).forEach(function (c) {
        var ok = !!validos[valorDe(c)];
        c.hidden = !ok;
        if (ok && !primero) { primero = c; }
        if (ok && valorDe(c) === sel[i]) { sigue = true; }
      });
      if (!sigue && primero) {
        chipsDe(grupos[i]).forEach(function (c) { c.setAttribute("aria-pressed", "false"); });
        primero.setAttribute("aria-pressed", "true");
        sel[i] = valorDe(primero);
      }
    }
  }

  /* ── Ficha de producto ── */
  var datos = document.querySelector("[data-variantes]");
  var ficha = document.getElementById("form-producto");
  if (datos && ficha) {
    var vars = [];
    try { vars = JSON.parse(datos.textContent); } catch (e) { vars = []; }
    ajustar(ficha, vars, null);
    /* La guia de tallas explica Fan/Player cuando hay dos opciones; con
       Corte + Talla ese parrafo no aplica. */
    var esCorte = Array.prototype.some.call(ficha.querySelectorAll(".pdp-opt legend"), function (l) { return /corte/i.test(l.textContent); });
    if (esCorte) {
      Array.prototype.forEach.call(document.querySelectorAll(".pdp-mas p"), function (p) {
        if (/Player/.test(p.textContent)) { p.textContent = "Mujer: corte entallado, tallas S a XL. Niño: tallas 20 (6-7 años) a 26 (12-13 años)."; }
      });
    }
    ficha.addEventListener("click", function (e) {
      var c = e.target.closest(".pdp-opt .chip");
      if (!c) { return; }
      ajustar(ficha, vars, { fs: c.closest(".pdp-opt"), valor: valorDe(c) });
    }, true);
    /* tlr.js busca la variante con lo que esta marcado al cargar: la
       primera talla visible ya quedo marcada, solo falta refrescar. */
    var marcada = ficha.querySelector('.pdp-opt .chip[aria-pressed="true"]');
    if (marcada) { setTimeout(function () { marcada.click(); }, 0); }
  }

  /* ── Vista rapida ── */
  var hoja = document.getElementById("vista-rapida");
  var cuerpo = hoja && hoja.querySelector("[data-vr-cuerpo]");
  if (!cuerpo) { return; }
  var cache = {};
  function variantesDe(cb) {
    var a = cuerpo.querySelector(".vr-foto");
    var h = a && (a.getAttribute("href") || "").split("/products/")[1];
    if (!h) { return; }
    h = h.split("?")[0];
    if (cache[h]) { cb(cache[h]); return; }
    fetch("/products/" + h + ".js").then(function (r) { return r.json(); })
      .then(function (p) { cache[h] = p.variants || []; cb(cache[h]); }).catch(function () {});
  }
  new MutationObserver(function () {
    if (!cuerpo.querySelector("[data-vr-op]")) { return; }
    variantesDe(function (vs) {
      ajustar(cuerpo, vs, null);
      var m = cuerpo.querySelector('[data-vr-op][aria-pressed="true"]');
      if (m) { m.click(); }
    });
  }).observe(cuerpo, { childList: true });
  cuerpo.addEventListener("click", function (e) {
    var c = e.target.closest("[data-vr-op]");
    if (!c) { return; }
    var a = cuerpo.querySelector(".vr-foto");
    var h = a && (a.getAttribute("href") || "").split("/products/")[1];
    var vs = h && cache[h.split("?")[0]];
    if (vs) { ajustar(cuerpo, vs, { fs: c.closest(".pdp-opt"), valor: valorDe(c) }); }
  }, true);
})();